import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { InputDollar } from "@/components/_pages/ModelPage/Sidebar/InputDollar";
import {
  inputWorkingCapitalBuyerCashAtom,
  isEquityInvestorsIncludedAtom,
  workingCapitalEquityContributorAtom,
  workingCapitalFundingSourceAtom,
  workingCapitalIncludedAtom,
} from "@/financeModels/owasco/general";
import { toNumberOrNull } from "@/utils/math";
import { Stack } from "@mantine/core";
import { useAtom } from "jotai";
import { ChangeEvent } from "react";
import { TbCoins } from "react-icons/tb";
import { InputSelect } from "../../Sidebar/InputSelect";
import { InputToggle } from "../../Sidebar/InputToggle";

const Panel = () => {
  const [buyerCash, setBuyerCash] = useAtom(inputWorkingCapitalBuyerCashAtom);
  const [workingCapitalIncluded, setWorkingCapitalIncluded] = useAtom(
    workingCapitalIncludedAtom,
  );

  const [fundingSource, setFundingSource] = useAtom(
    workingCapitalFundingSourceAtom,
  );

  const [equityContributor, setEquityContributor] = useAtom(
    workingCapitalEquityContributorAtom,
  );

  const [isEquityInvestorsIncluded] = useAtom(isEquityInvestorsIncludedAtom);

  // const [sellerCash, setSellerCash] = useAtom(workingCapitalSellerCashAtom);
  // const [sellerAccts, setSellerAccts] = useAtom(
  //   workingCapitalSellerAccountsReceivableAtom,
  // );
  // const [sellerInventory, setSellerInventory] = useAtom(
  //   workingCapitalSellerInventoryAtom,
  // );
  // const [sellerPrepaid, setSellerPrepaid] = useAtom(
  //   workingCapitalSellerPrepaidExpensesAtom,
  // );
  // const [sellerOther, setSellerOther] = useAtom(
  //   workingCapitalSellerOtherCurrentAssetsAtom,
  // );

  // const workingCapitalTotal = useAtomValue(workingCapitalTotalAtom);

  return (
    <Stack gap={4}>
      <InputToggle
        label={
          <LabelExplainer
            label="Fund additional working capital?"
            explanation={
              <Doc path="@/docs/pages/model/sidebar/workingCapitalIncluded.mdx" />
            }
          />
        }
        checked={workingCapitalIncluded}
        onChange={(event) => {
          setWorkingCapitalIncluded(
            (event as ChangeEvent<HTMLInputElement>).currentTarget.checked,
          );
        }}
      />

      {workingCapitalIncluded && (
        <>
          <InputDollar
            value={Number(buyerCash)}
            onChange={(val) => setBuyerCash(toNumberOrNull(val))}
            label={
              <LabelExplainer
                label="Working Capital Amount"
                explanation={
                  <Doc path="@/docs/pages/model/sidebar/workingCapitalBuyerCash.mdx" />
                }
              />
            }
          />

          <InputSelect
            labelWidth={172}
            label={
              <LabelExplainer
                label="Funding Source"
                explanation={
                  <Doc path="@/docs/pages/model/sidebar/workingCapitalFundingSource.mdx" />
                }
              />
            }
            data={[
              { value: "equity", label: "Equity" },
              { value: "seniorDebt", label: "Senior Debt" },
            ]}
            value={fundingSource}
            onChange={(value) =>
              setFundingSource(value as "equity" | "seniorDebt")
            }
          />

          {fundingSource === "equity" && (
            <InputSelect
              labelWidth={172}
              label={
                <LabelExplainer
                  label="Equity Contributor"
                  explanation={
                    <Doc path="@/docs/pages/model/sidebar/workingCapitalEquityContributor.mdx" />
                  }
                />
              }
              data={[
                ...(isEquityInvestorsIncluded
                  ? [{ value: "investors", label: "Investors" }]
                  : []),
                { value: "searcher", label: "Searcher" },
              ]}
              value={equityContributor}
              onChange={(value) =>
                setEquityContributor(value as "investors" | "searcher")
              }
            />
          )}
        </>
      )}
    </Stack>
  );
};

export const ModuleWorkingCapital = {
  key: "Working Capital",
  icon: <TbCoins />,
  control: "Working Capital",
  panel: <Panel />,
};
